import React from "react";
import BookableTranslations from "../../Bookable/ModuleTranslations/en";
import {
  RATE_TYPE,
  RESTRICTION_TYPE,
  DEVICE_TYPE,
  CODE_TYPE,
  SHARING_TYPE,
  RESTRICTION_VALUE_TYPE,
} from "../../../Common/constants";
import { removeIconSetIdentifier } from "../ModuleDefinition";
import { getTranslatedCountryList } from "../../../../../lib/intlUtils";

const customBookableTranslations = BookableTranslations.fields.form.map(field => {
  if (field.fieldName === "isVisible") {
    field.displayName = "Visible on the booking engine";
  }
  return field;
});

export default {
  locale: "en",
  name: "Promotions",
  filterFields: [
    ["isActive", "bool"],
    ["isVisible", "bool"],
    "ticker",
    "name",
    [
      "promotionType",
      "selector",
      [
        { label: "Discount % ", value: RATE_TYPE.PERCENTAGE },
        { label: "Highlight", value: RATE_TYPE.HIGHLIGHT_MESSAGE },
        { label: "Disc. fix/day", value: RESTRICTION_VALUE_TYPE.MONEY },
        { label: "3x2 type", value: RATE_TYPE.GIVE_NIGHT },
      ],
    ],
    [
      "group",
      "selector",
      [
        { label: "One", value: "1" },
        { label: "Two", value: "2" },
        { label: "Three", value: "3" },
        { label: "Four", value: "4" },
        { label: "Five", value: "5" },
        { label: "Six", value: "6" },
        { label: "Seven", value: "7" },
        { label: "Eight", value: "8" },
        { label: "Nine", value: "9" },
        { label: "Ten", value: "10" },
      ],
    ],
    "CODE",
    [
      "sharingType",
      "selector",
      [
        { label: "-", value: SHARING_TYPE.SIMPLE },
        { label: "Shared", value: SHARING_TYPE.SHARED },
      ],
    ],
  ],
  translation: { displayName: "Translations" },
  tabs: [
    {
      title: {
        create: "Setting",
        edit: "Edit",
      },
    },
    {
      title: "Single-use promocode",
    },
  ],
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Id",
      },
      {
        fieldName: "promotionType",
        displayName: "Typology",
      },
      {
        fieldName: "sharingType",
        displayName: "Use",
      },
      ...BookableTranslations.fields.list,
      {
        fieldName: "group",
        displayName: "Group",
        tooltip: "Accumulation of promotions",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_TRAVEL}_value`,
        displayName: "Validity (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.CLOSE_TRAVEL}_value`,
        displayName: "Blocks (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_BOOKING}_value`,
        displayName: "Bookable (booking w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_STAY}_duration`,
        displayName: "Min. stay (nights)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_STAY}_duration`,
        displayName: "Max. stay (nights)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_NOTICE}_duration`,
        displayName: "Min. rel. (d) (Release)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_NOTICE}_duration`,
        displayName: "Max. rel. (d) (Release)",
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "Codes",
      },
      {
        fieldName: "type",
        displayName: "Type",
      },
    ],
    form: [
      {
        fieldName: "infoMessageChainPromo",
        value: "Changes will apply to all selected properties",
      },
      ...customBookableTranslations,
      ...BookableTranslations.fields.form,
      {
        fieldName: "rateTypeSection",
        displayName: "Typology",
      },
      {
        fieldName: "rateType",
        options: [
          {
            ticker: RATE_TYPE.PERCENTAGE,
            name: "Discount %",
          },
          {
            ticker: RATE_TYPE.CONSTANT,
            name: "Disc. fix/day",
          },
          {
            ticker: RATE_TYPE.GIVE_NIGHT,
            name: "Give away night/s (ie.3x2)",
          },
          {
            ticker: RATE_TYPE.HIGHLIGHT_MESSAGE,
            name: "Highlight message",
          },
        ],
      },
      {
        fieldName: "group",
        displayName: "Group",
      },
      {
        fieldName: "ratePercentage",
        displayName: "Quantity",
        helpText:
          "Percentage of discount that will be applied to the price of the accommodation subject to the promotion",
      },
      {
        fieldName: "rateConstant",
        displayName: "Quantity",
        helpText:
          "Fixed discount per day that will be applied to the price of the accommodation subject to the promotion",
      },
      {
        fieldName: "accumulationPromotions",
        openContainerText: "See accumulation of promotions",
        closeContainerText: "Hide accumulation of promotions",
      },
      {
        fieldName: "accumulationPromotionsSection",
        displayName: "Accumulation of promotions",
        subtitle:
          "Only promos belonging to different groups will be accumulated, if there are several applicable promos from the same group, the one with the greatest benefit will be chosen.",
      },
      {
        fieldName: RESTRICTION_TYPE.CLOSE_TRAVEL,
        displayName: "Block",
        description:
          "Allow disabling the promotion for certain dates in the Inventory> Management section",
      },
      {
        fieldName: "stayDatesSection",
        displayName: "Stay dates (travel window)",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE,
        displayName: "Start date",
        placeholder: "Enter a date",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE,
        displayName: "End date",
        placeholder: "Enter a date",
      },
      {
        fieldName: "codeType",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "No code",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Universal code",
          },
        },
      },
      {
        fieldName: "showPopup",
        displayName: "Show pop up with description of promotions",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restrictions",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_STAY,
        description: "Min. stay (nights)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_STAY,
        description: "Max. stay (nights)",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_NOTICE,
        description: "Min. release (days)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_NOTICE,
        description: "Max. release (days)",
      },
      {
        fieldName: "deviceSection",
        displayName: "Enabled Devices",
        subtitle: "This promotion will be applied to users connected from the chosen devices.",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "",
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Desktop",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablet",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Mobile",
          },
        ],
      },
      {
        fieldName: "geoLocationSection",
        displayName: "Geolocation",
        widget: "section",
        subtitle:
          "This promotion will only apply to the users with an IP originating from countries marked in the included countries list",
      },
      {
        fieldName: RESTRICTION_TYPE.GEOLOCATION,
        options: getTranslatedCountryList("en"),
        leftListHeader: "Included countries",
        rightListHeader: "Excluded countries",
      },
      {
        fieldName: "sharingType",
        displayName: "Use",
        optionDisplay: {
          [SHARING_TYPE.SIMPLE]: {
            label: "Only displayed in aggregator",
          },
          [SHARING_TYPE.SHARED]: {
            label: "Shared",
          },
        },
      },
      {
        fieldName: "appliesToInventoriesSection",
        displayName: "Inventory lines",
        subtitle: "This promotion will only apply to the selected inventory lines.",
      },
      {
        fieldName: "appliesToInventories",
        displayName: "Rooms with the promo enabled:",
        filterNames: ["Accommodation", "Conditions", "Configuration", "Meal Plan"],
      },
      {
        fieldName: "icon",
        displayName: "Icon",
        placeholder: "No icon",
        optionLabelRenderer: ({ value, name }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ fontSize: 6, marginRight: "5px" }}>
              <i className="material-icons">{removeIconSetIdentifier(value)}</i>
            </span>
            <span style={{ fontSize: 14 }}>{name}</span>
          </div>
        ),
      },
      {
        fieldName: "infoMessage",
        value:
          "To activate single-use promocodes tab, you must save a promotion first and access it again to edit.",
      },
      {
        displayName: "Booking Window",
        widget: "section",
        fieldName: "bookingWindowSection",
      },
      { fieldName: "bookingWindow", nestedTitle: "Booking Window" },
    ],
  },
  validation: {
    [RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE]: {
      constraints: {
        compare: {
          message: "^The end date must be greater than the start date.",
        },
      },
    },
    [RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE]: {
      constraints: {
        compare: {
          message: "^The end date must be greater than the start date and greater than today.",
        },
      },
    },
  },
};
